/*
 * Tenant interceptor to apply basic authentication into the http requests.
 */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from '@services/tenant.service';

export const InterceptorSkipHeader = 'X-Skip-Tenant';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(
    private tenantService: TenantService,
    
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // First check if interceptor should be skipped
    if (request.headers.has(InterceptorSkipHeader)) {
      const headers = request.headers.delete(InterceptorSkipHeader);
      return next.handle(request.clone({ headers }));
    }

    //Only go if auth header isn't set yet.
    if (request.headers.get("AnonAuthorization") == undefined) {
      // Add the bearer if a tenant exists.
      let tenant: string = this.tenantService.activeTenant;

      if (tenant) {
        request = request.clone({
          setHeaders: {
            AnonAuthorization: 'Basic ' + btoa(`alias:${tenant}`)
          }
        });
        return next.handle(request);
      } else {
        //Return the original request, if no tenant is set.
        return next.handle(request);
      }
    }
    // Replace the alias if header differs from active tenant to prevent inserts into the wrong database.
    else if (request.headers.get("AnonAuthorization") !== this.tenantService.activeTenant) {
      request = request.clone({
        setHeaders: {
          AnonAuthorization: 'Basic ' + btoa(`alias:${this.tenantService.activeTenant}`)
        }
      });
      return next.handle(request);
    }
    
    //Return the original if the auth headers were preset.
    return next.handle(request);    
  }
}
